import script from "./MarcaLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./MarcaLogo.vue?vue&type=script&setup=true&lang=js"

import "./MarcaLogo.vue?vue&type=style&index=0&id=3d4214da&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4214da"]])

export default __exports__